import { render, staticRenderFns } from "./OwnReview.vue?vue&type=template&id=879e6626&scoped=true"
import script from "./OwnReview.vue?vue&type=script&lang=js"
export * from "./OwnReview.vue?vue&type=script&lang=js"
import style0 from "./OwnReview.vue?vue&type=style&index=0&id=879e6626&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879e6626",
  null
  
)

export default component.exports